module.exports = __webpack_public_path__ + "img/error.956ec8ac.svg";